import {
  Section,
  RHFCircleToggleGroupChildren,
  RHFRadioGroup,
} from "@arp/react-ndbx";
import { Typography } from "@mui/material";
import React from "react";
import { AURA_QUESTION } from "../../config/const/enums";

function AuraSingleChoiceQuestion({ mappedContent }) {
  return (
    <>
      <Section md={7}>
        {mappedContent.context && (
          <Section mb={3}>
            <Typography
              mb={4}
              sx={{
                width: "fit-content !important",
              }}
              variant="label-large-bold"
            >
              {mappedContent.context}
            </Typography>
          </Section>
        )}
        {mappedContent.statement && (
          <Typography
            sx={{
              marginBottom: 5 / 2,
              display: "flex",
              textAlign: "center",
              justifyContent: "center",
            }}
            variant="label-large-bold"
          >
            {mappedContent.statement}
          </Typography>
        )}
        {mappedContent.hasYesAndNoOptions ? (
          <RHFCircleToggleGroupChildren
            variant="circle-group"
            name={AURA_QUESTION.AURA_QUESTION_NAME}
            items={mappedContent.answerOptionList}
            minHeight={50}
            showTooltip={mappedContent.richHelpText ? true : false}
            tooltipText={mappedContent.richHelpText}
          >
            <Typography
              sx={{
                width: "fit-content !important",
                marginBottom: 4,
                textAlign: "center",
                justifyContent: "center",
              }}
              variant="label-large-bold"
              dangerouslySetInnerHTML={{ __html: mappedContent.richText }}
            ></Typography>
          </RHFCircleToggleGroupChildren>
        ) : (
          <RHFRadioGroup
            name={AURA_QUESTION.AURA_QUESTION_NAME}
            label={mappedContent.richText}
            items={mappedContent.answerOptionList}
            radioPosition="flex-start"
          />
        )}
      </Section>
    </>
  );
}

export default AuraSingleChoiceQuestion;
